import { type SvgIconProps } from '@common/components/svgs/props';

function IconStatusCheck(
  { size = 24, color = 'scheme-feedback-action-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-Check"
    >
      <path
        d="M5 12C5 8.13401 8.13401 5 12 5C12.9301 5 13.8155 5.18088 14.6248 5.50845L15.3752 3.65458C14.3316 3.23213 13.1917 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.4817 20.9561 10.973 20.8716 10.4774L18.9 10.8136C18.9657 11.1986 19 11.5949 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12Z"
        fill={`var(--${color})`}
      />
      <path
        d="M11.0001 15.4142L20.7072 5.70712L19.293 4.29291L11.0001 12.5858L8.70718 10.2929L7.29297 11.7071L11.0001 15.4142Z"
        fill={`var(--${color})`}
      />
    </svg>
  );
}

IconStatusCheck.displayName = 'Status-Check';

export default IconStatusCheck;
